angular.module('impactx.imageUpload').service('ImageEditor', [
    '$mdDialog',
    ImageEditor
]);

function ImageEditor($mdDialog) {
    function open(event, currentImage, newImage, areaType, useIxBackImage) {
        return $mdDialog.show({
                controller: 'ImageEditorCtrl',
                controllerAs: '$ctrl',
                templateUrl: 'shared/imageUpload/templates/image-editor.tmpl.html',
                targetEvent: event,
                clickOutsideToClose: false,
                hasBackdrop: true,
                disableParentScroll: true,
                bindToController: true,
                locals: {
                    currentImage: currentImage,
                    newImage: newImage,
                    areaType: areaType,
                    useIxBackImage: useIxBackImage
                }
            }
        ).then(function (result) {
            if (result && ( result.image || result.deleted )) {
                return result;
            }
        });
    }

    return {
        open: open
    };
}